import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Colors, Utils } from "./config";
import { ComponentsSample } from "./containers";
import { Loader, Popup } from "./components";
import AuthRoutes from "./config/routes/AuthRoutes";

import "./App.css";
import { useLocation, useNavigate } from "react-router-dom";
import AlertCard from "./components/EmergencyAlert";
import { messaging, onMessage } from "./config/firebase/firebase";
import { AppAction, GeneralActions } from "./store/actions";
import Notifications from "./components/Notification";
import PushNotifications from "./components/Notification";

const { saveSnackbarRef } = Utils;

const App = () => {

  const [messageApi, contextHolder] = message.useMessage();
  const loader = useSelector((state) => state.AppReducer.loader);
  const user = useSelector((state) => state.AppReducer?.user);
  const [isEmergencyAlert, setIsEmergencyAlert] = useState(false);
  const [emergencyAlertDetail, setEmergencyAlertDetail] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { isNotification, data, chatChannelId, notificationCount } = useSelector((state) => state?.GeneralReducer)

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // foreground notifications listener.
  // different cases handled.
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      if (payload) {
        console.log("notification payload: ", payload)
        // checking type if it is security alert then our component will be shown in place of these
        // notifications.
        if (payload?.data?.type == 'securityAlertReported') {
          setIsChatOpen(false);
          setIsEmergencyAlert(true)
          setEmergencyAlertDetail(payload?.notification)
          dispatch(GeneralActions.SetNotificationCount(notificationCount + 1))
        }

        // if the chat channel is open and the notification pops up for the same chat channel
        // no need to show it as it will update on real time.
        else if (chatChannelId == payload?.data?.recordId) {
          setIsChatOpen(true)
        }

        // for normal notifications
        else {
          setIsChatOpen(false);
          dispatch(GeneralActions.TriggerNotification({
            isNotification: true,
            data: payload?.notification
          }))
          dispatch(GeneralActions.SetNotificationCount(notificationCount + 1))
        }
      }
    });
    return () => {
      unsubscribe()
      dispatch(GeneralActions.SetChatChanneId(null))
    }
  }, []);

  return (
    <div>
      {isNotification && !isChatOpen && <PushNotifications notificationData={data} />}
      {contextHolder}
      {
        isEmergencyAlert &&
        <AlertCard
          content={emergencyAlertDetail}
          onCancel={() => {
            navigate(location?.pathname)
            setIsEmergencyAlert(false)
          }}
          onSuccess={() => {
            navigate('/alert-management')
            setIsEmergencyAlert(false)
          }}
        />
      }
      {
        !isEmergencyAlert && <AuthRoutes />
      }
      {/* <Popup.Snackbar ref={(ref) => saveSnackbarRef(ref)} /> */}

      {/* {loader ? (
        <div
          style={{
            display: "flex",
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: Colors.BlackOpacity(0.7),
          }}
        >
          <Loader.Circular size={60} color={colorPrimary} />
        </div>
      ) : null} */}

      {/* <ComponentsSample /> */}
    </div>
  );
};

export default App;
